import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { EmailApiService } from './services/email-api.service';
import { BigLoginApiService } from './services/big-login-api.service';
import { ReferenceDataApiService } from './services/reference-data-api.service';
import { SearchApiService } from './services/search-api.service';
import { UserInfoApiService } from './services/user-info-api.service';
import { RegistrationApiService } from './services/registration-api.service';
import { CaseApiService } from './services/case-api.service';
import { HcpApiService } from './services/hcp-api.service';
import { CorrespondenceApiService } from './services/correspondence-api.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ZorroSpinnerInterceptor } from './interceptors/zorro-spinner-interceptor';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ResourceApiService } from './services/resource-api.service';
import { CancelReregistrationApiService } from './services/cancel-reregistration-api.service';
import { CertificateApiService } from './services/certificate-api.service';
import { DeregistrationApiService } from './services/deregistration-api.service';
import { LoggingApiService } from './services/logging-api.service';
import { PaymentApiService } from './services/payment-api.service';
import { RegisterApiService } from './services/register-api.service';
import { ReregisterApiService } from './services/reregister-api.service';
import { SessionDataApiService } from './services/session-data-api.service';
import { StatementApiService } from './services/statement-api.service';
import { TeaApiService } from './services/tea-api.service';

@NgModule({ exports: [
        SpinnerComponent
    ],
    imports: [BrowserModule, SpinnerComponent], providers: [
        BigLoginApiService,
        CancelReregistrationApiService,
        CaseApiService,
        CertificateApiService,
        CorrespondenceApiService,
        DeregistrationApiService,
        EmailApiService,
        HcpApiService,
        LoggingApiService,
        PaymentApiService,
        ReferenceDataApiService,
        RegisterApiService,
        RegistrationApiService,
        ReregisterApiService,
        ResourceApiService,
        SearchApiService,
        SessionDataApiService,
        StatementApiService,
        TeaApiService,
        UserInfoApiService,
        ZorroSpinnerInterceptor,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class ZorroClientModule { }
